import { render } from "./Party.vue?vue&type=template&id=2061c924&ts=true"
import script from "./Party.vue?vue&type=script&lang=ts"
export * from "./Party.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__